import React from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { HOTEL_DETAILS_SECTION_ORDER_FUNNEL, HOTEL_DETAILS_SECTION_ORDER_LP, HOTEL_DETAILS_PAGE_SECTION_KEYS, } from './HotelDetails.constants';
/**
 * Parses a pipe-delimited string into a validated list of HotelDetailsPageSectionKeys.
 * Invalid or unknown keys are filtered out.
 */
function parseHotelDetailsSectionOrder(rawValue) {
    return rawValue
        .split('|')
        .filter((key) => HOTEL_DETAILS_PAGE_SECTION_KEYS.includes(key));
}
export const useHotelDetailsPageSectionOrder = (pageVariant) => {
    const { configSettings: { HotelLandingPageComponentOrder, HotelFunnelPageComponentOrder }, } = useGlobalContext();
    return React.useMemo(() => {
        const isFunnel = pageVariant === 'funnel';
        const overrideOrder = parseHotelDetailsSectionOrder(isFunnel ? HotelFunnelPageComponentOrder : HotelLandingPageComponentOrder);
        if (overrideOrder.length > 0) {
            // Use the override ordering from config
            return overrideOrder;
        }
        // Use the default ordering
        return isFunnel ? HOTEL_DETAILS_SECTION_ORDER_FUNNEL : HOTEL_DETAILS_SECTION_ORDER_LP;
    }, [pageVariant, HotelLandingPageComponentOrder, HotelFunnelPageComponentOrder]);
};
